import * as React from "react";
import {LegalDocument} from "@/api/data-contracts";
import {LegalDocumentView} from "@/pages/info-pages/LegalDocumentView";

export const PrivacyPage = () => <LegalDocumentView document={LegalDocument.PRIVACY_POLICY}/>;
